import posthtml from 'posthtml/lib';
import { addInfoComponents } from './utils';
export const addSiteInfo = (mjml, options, t) => {
  const siteInfo = tree => {
    const siteInfoComponent = {
      tag: 'mj-section',
      attrs: {
        padding: '18px 0px',
        'background-color': '#fff',
        'css-class': 'site-info-section',
        'full-width': 'full-width'
      },
      content: [{
        tag: 'mj-column',
        attrs: {
          width: '100%'
        },
        content: addInfoComponents(options, t)
      }]
    };
    tree.match({
      tag: 'mjml'
    }, mjmlNode => {
      if (!mjmlNode.content) {
        mjmlNode.content = [];
      }
      mjmlNode.content.forEach(child => {
        if (child.tag === 'mj-body') {
          if (!child.content) {
            child.content = [];
          }
          child.content.push(siteInfoComponent);
        }
      });
      return mjmlNode;
    });
  };
  const withSiteInfo = posthtml([siteInfo]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withSiteInfo.html;
};
//# sourceMappingURL=add-site-info.js.map